export default __webpack_public_path__ + "static/media/click.b30189ca.svg";